import * as Api from '../../utils/request'

let baseURL = '';
if (process.env.NODE_PM === 'prod') {
    baseURL = 'https://quote.aigupiao.com';
} else if (process.env.NODE_PM === 'dev') {
    baseURL = 'https://quotedev.stock-ring.com';
} else if (process.env.NODE_PM === 'beta') {
    baseURL = 'https://quotebeta.stock-ring.com';
}

export default {
    //获取股指期货
    async getStockFuture(sort){
        return await Api.get({
            url:baseURL+'/api/sina_future.php',
            params:{
                sort:sort
            }
        })
    },
    //获取分享的数据
    async getShare(){
        return await Api.get({
            url:'/H5/index_futures_share',
            params:{

            }
        })
    },
}
